import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withToast } from "../../contexts/toastr.context";
import useModel from "../../hooks/use-model.hook";
import { PostService } from "../../_service";
import { Avatar } from "../avatar.component";
import IconButton2 from "../icon-button-2-component";
import { Loader } from "../loader.component";
import { Modal } from "../modal.component";

/**
 * Get community subscribers with group role
 * @param {*} param0
 * @returns
 */
function PostLikesComponent({
  addToast,
  post,
  user,
  group,
  community,
  isUpvotingUsersListVisible,
  setIsUpvotingUsersListVisible,
}) {
  // get list of users who like
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [areLikesLoaded, setAreLikesLoaded] = useState(false);

  const {
    profileModelState: { setShowProfileModel, setIdToViewProfile },
  } = useModel();

  // load the likes list, per post change
  useEffect(() => {
    if (user && isUpvotingUsersListVisible && !areLikesLoaded) {
      setIsLoading(true);
      PostService.getPostLikes(user, post.id)
        .then(({ users }) => {
          setUsers(users);
          setAreLikesLoaded(true);
        })
        .catch((err) => {
          console.log({ err });
          addToast("Likes could not be loaded!");
        })
        .finally((e) => {
          setIsLoading(false);
        });
    }
  }, [user, post, isUpvotingUsersListVisible, areLikesLoaded]);

  return (
    <div className="">
      <div
        style={{
          marginLeft:
            post.likes < 3 ? 24 + post.likes * 10 + "px" : 24 + 3 * 10 + "px",
        }}
        className="text-xs">
        {post.latestLikes[0].name}{" "}
        {post.likes > 1
          ? ` & ${post.likes - 1} other${post.likes > 2 ? "s" : ""}`
          : ""}{" "}
        liked
      </div>
      {/* subscriber list */}
      <Modal
        setActive={setIsUpvotingUsersListVisible}
        active={isUpvotingUsersListVisible}
        padding={false}>
        {/* headers */}
        <div className="flex items-center justify-between bg-card py-2 pl-4 pr-2">
          <span className="font-bold text-secondary-foreground/80">
            {isLoading ? (
              <div className="p-1">
                <Loader />
              </div>
            ) : (
              <>
                {users.length} Upvote{users.length === 1 ? "" : "s"}
              </>
            )}
          </span>
          <IconButton2
            icon="cross"
            size="sm"
            onClick={() => {
              setIsUpvotingUsersListVisible(false);
            }}
          />
        </div>
        {/* body */}
        <div className="p-5 pb-24 text-secondary-foreground/80">
          {/* upvoters list */}
          {users.map((u) => (
            <div
              className="m-3 flex cursor-pointer items-center justify-between"
              key={u.id}>
              <div className="flex items-center justify-center">
                <Avatar
                  user={u}
                  onClick={() => {
                    // open the user page
                    // window.open(createUserWallPageRoute(u.id, "activity"));
                    setShowProfileModel(true);
                    setIdToViewProfile(u.id);
                  }}
                  tag={
                    u.groupRole === "admin" ? (
                      <div className="text-xxs mx-2 rounded bg-blue-50 px-1 font-semibold text-blue-500">
                        Admin
                      </div>
                    ) : u.groupRole === "moderator" ? (
                      <div className="text-xxs mx-2 rounded bg-green-50 px-1 font-semibold text-green-500">
                        Moderator
                      </div>
                    ) : (
                      <></>
                    )
                  }
                  extraInfo={[u.mobile, u.email].filter((e) => e).join(" · ")}
                />
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}

const PostLikes = withToast(
  connect((s) => ({
    user: s.auth,
    group: s.activeGroup,
    community: s.community,
  }))(PostLikesComponent)
);

export default PostLikes;
